import { ContactPerson } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

import { IconFieldComponent } from '../../icon-field';

import { ContactRolePipe } from '@wo-mc/organizations';
import { DeepPartial } from '@iss/wo-common/types';

@Component({
  selector: 'wo-contact-person',
  templateUrl: './contact-person.component.html',
  styleUrls: [ './contact-person.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContactRolePipe,
    IconFieldComponent,
    NgIf,
  ],
})
export class ContactPersonComponent {
  @Input() public person?: DeepPartial<ContactPerson> | null;

  public get displayName(): string {
    return [ this.person?.firstName, this.person?.surname ].filter(Boolean).join(' ') || 'Anonymous';
  }
}
